import React from 'react';
import { authentication, staticPages } from '../menu';
import Footer from '../layout/Footer/Footer';

const footers = [
	// { path: layoutMenu.blank.path, element: null, exact: true },
	{ path: authentication.login.path, element: null, exact: true },
	{ path: authentication.signUp.path, element: null, exact: true },
	{ path: staticPages.page404.path, element: null, exact: true },
	// { path: demoPages.knowledge.subMenu.grid.path, element: null, exact: true },
	{ path: '*', element: <Footer /> },
];

export default footers;
